import { z } from 'zod';
import { fr } from 'zod/locales';

z.config(fr());
